import { render, staticRenderFns } from "./TermsAndConditionForm.vue?vue&type=template&id=0c833b49&"
import script from "./TermsAndConditionForm.vue?vue&type=script&lang=ts&"
export * from "./TermsAndConditionForm.vue?vue&type=script&lang=ts&"
import style0 from "./TermsAndConditionForm.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports